import { render } from "./OrganizationList.vue?vue&type=template&id=ad18d970&scoped=true"
import script from "./OrganizationList.vue?vue&type=script&lang=js"
export * from "./OrganizationList.vue?vue&type=script&lang=js"

import "./OrganizationList.vue?vue&type=style&index=0&id=ad18d970&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad18d970"],['__file',"src/views/UserManagement/OrganizationManagement/components/OrganizationList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad18d970"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad18d970', __exports__)) {
    api.reload('ad18d970', __exports__)
  }
  
  module.hot.accept("./OrganizationList.vue?vue&type=template&id=ad18d970&scoped=true", () => {
    api.rerender('ad18d970', render)
  })

}


export default __exports__